import { db } from "@/api/firebase";
import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { toArray } from "lodash";
import { LeaderBoardTeams } from "@/models/LeaderBoardTeams";
import { LeaderBoard } from "@/models/LeaderBoard";
import { Game } from "@/models/Game";

@Module({ namespaced: true })
export default class LeaderBoardStore extends VuexModule {
  leaderBoard: LeaderBoard[] = [];

  @Mutation
  setLeaderBoard(leaderBoard: LeaderBoard[]): void {
    this.leaderBoard = leaderBoard;
  }

  @Action({ rawError: true })
  public async getAllLeaderBoardForGameTeams(
    key: string
  ): Promise<LeaderBoardTeams[]> {
    const results = await db
      .ref("leaderboards")
      .child(key)
      .child("team_stats")
      .orderByChild("timer/comp_dur_s")
      .once("value");
    return results.val();
  }

  @Action({ rawError: true })
  public async getAllLeaderBoardForGames(date: any): Promise<LeaderBoard[]> {
    const results = await db
      .ref("leaderboards")
      .orderByChild("meta/start_dt")
      .startAt(date.startDate)
      .endBefore(date.endDate)
      .once("value");
    return toArray(results.val());
  }

  @Action({ rawError: true })
  public async getIndividualLeaderBoardForGame(
    data: any
  ): Promise<LeaderBoardTeams[]> {
    const results = await db
      .ref("leaderboards")
      .child(data.key)
      .child("team_stats")
      .child(data.team_id)
      .once("value");
    return results.val();
  }
}
